window.addEventListener('CookiebotOnConsentReady', () => {
    if (!window?.Cookiebot?.consent?.marketing) {
        window.localStorage.removeItem('stored-input-values');
    }
}, false);
